import styled, { css } from 'styled-components'

import { media } from '../../themes'

interface ContainerProps {
  modifier: string
  padded: boolean
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  padding-bottom: ${({ padded }) => (padded ? '30px' : '0')};

  .${({ modifier }) => modifier}-horizontal {
    position: static;
  }

  .${({ modifier }) => modifier}-horizontal > .swiper-pagination-bullets {
    bottom: 8px;
    left: 0;
    width: 100%;
    z-index: 10;

    & > .swiper-pagination-bullet {
      margin: 0 4px;
    }

    & > .swiper-pagination-bullet-active {
      background: ${({ theme }) => theme.colors.gradient.primary};
    }
  }
`

interface ControlProps {
  next: string
  prev: string
  hideControlsOnMobile?: boolean
}

export const Controls = styled.div<ControlProps>`
  position: relative;
  margin-top: 24px;
  // Height of navigation icons
  min-height: 27px;

  ${({ hideControlsOnMobile }) =>
    hideControlsOnMobile &&
    css`
      display: none;

      ${media.tablet} {
        display: block;
      }
    `}

  .${({ prev }) => prev}, .${({ next }) => next} {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 10;
    display: none;

    ${media.tablet} {
      display: block;
    }

    &.swiper-button-disabled {
      opacity: 0.5;
    }
  }

  .${({ prev }) => prev} {
    left: calc(50% - 240px);
  }

  .${({ next }) => next} {
    right: calc(50% - 240px);
  }

  .buttonWrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      width: 256px;
    }
  }
`
